import { useContestMaintenance } from "../hooks";
import { Modal, Button, Table, Spinner } from "flowbite-react";
import { numberToCurrency } from "@/common/helpers/currency.helpers";
import { STATUS_LABELS_CONTEST_MAINTENANCE } from "@/types/contest-maintenance.type";

interface ContestMaintenanceDetailsModalProps {
  contestMaintenanceId: string;
  show: boolean;
  onClose: () => void;
}

export function ContestMaintenanceDetailsModal({
  contestMaintenanceId,
  show,
  onClose,
}: ContestMaintenanceDetailsModalProps) {
  const { data, isLoading } = useContestMaintenance(contestMaintenanceId);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const budgetMaintenance = (data?.data?.contestMaintenance as any)
    ?.budgetMaintenance;

  const allProducts = [
    ...(budgetMaintenance?.corrective || []),
    ...(budgetMaintenance?.preventive || []),
    ...(budgetMaintenance?.misuse || []),
  ];

  return (
    <Modal show={show} onClose={onClose}>
      <Modal.Header>
        <h2 className="text-black dark:text-black">Detalhes da Contestação</h2>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="flex justify-center">
            <Spinner />
          </div>
        ) : (
          <div className="space-y-4">
            <p>
              <span className="font-semibold">Responsável:</span>{" "}
              {data?.data?.createdByName}
            </p>
            <p>
              <span className="font-semibold">Placa:</span>{" "}
              {data?.data?.contestMaintenance?.licensePlate}
            </p>
            <p>
              <span className="font-semibold">Status:</span>{" "}
              {
                STATUS_LABELS_CONTEST_MAINTENANCE[
                  data?.data?.contestMaintenance?.status as string
                ]
              }
            </p>
            <p>
              <span className="font-semibold">Mensagem:</span>{" "}
              {data?.data?.contestMaintenance?.message}
            </p>
            <p>
              <span className="font-semibold">Data de Criação:</span>{" "}
              {new Date(
                data?.data?.contestMaintenance?.createdAt as Date
              ).toLocaleString()}
            </p>

            <h3 className="font-semibold">Produtos Contestados</h3>
            <Table striped>
              <Table.Head>
                <Table.HeadCell>Nome</Table.HeadCell>
                <Table.HeadCell>Preço</Table.HeadCell>
              </Table.Head>
              <Table.Body className="divide-y divide-black">
                {allProducts.length > 0 ? (
                  allProducts.map((product, index) => (
                    <Table.Row key={product.productOrWorkId || index}>
                      <Table.Cell className="capitalize">
                        {product.type}
                      </Table.Cell>
                      <Table.Cell>{product.name}</Table.Cell>
                      <Table.Cell>
                        {numberToCurrency(
                          product.sellPrice || product.price || 0
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row>
                    <Table.Cell colSpan={3} className="text-center">
                      Nenhum produto encontrado.
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="bg-red-600" onClick={onClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
